import { connect } from 'react-redux';
import ClientSummary from './ClientSummary';

import { deleteClient } from './actions';
import { setClient } from '../../AddClient/actions';

const mapStateToProps = state => ({
    clientsList: state.addClientUI.clientsList,
    toggleDelete: state.settings.toggleDelete,
});


const mapDispatchToProps = dispatch => ({
    deleteClient: authToken => dispatch(deleteClient(authToken)),
    setClient: client => dispatch(setClient(client)),

});


export default connect(mapStateToProps, mapDispatchToProps)(ClientSummary);



// WEBPACK FOOTER //
// ./src/containers/ClientsList/ClientSummary/index.js